export const PropertyPortalMerchandisingMock = {
  type: 'mi-aem-common-spa/components/content/cardcarouselcontainer',
  componentProps: {
    model: {
      componentId: 'merchendising-layered-wide',
      headerText: 'Recommended For You',
      cardTypes: 'cardlayered',
      cardCount: 2,
      noOfCards: 2,
      pagePath: '/content/marriott-hws/na/en-us/hotels/n/nycmq-new-york-marriott-marquis/ppv5-phoenix/homepage',
      trackingProperties: {
        enableScrollingBehavior: false,
        trackingDescription: '',
        impressionTrack: false,
        description: '',
        trackingContentPosition: '',
        atCCeVar48: '',
        rightArrowDesc: '',
        cardLocation: '',
        leftArrowDesc: '',
        clickTrack: true,
        location: '',
        merchandisingCategory: '',
        impressionCount: false,
        trackingTag: '',
        trackingOfferType: '',
      },
      variation: 'standard',
      isAuthor: false,
      ':items': {
        'card-0': {
          ':items': {
            cardlayered: {
              dynamicMedia: {
                altText: 'Healthy Breakfast',
                assetPath: 'https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100',
                enableSmartCrop: true,
                dynamic: true,
                renditions: [
                  {
                    renditionPath:
                      'https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Square?wid=365&fit=constrain, https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Square?wid=730&fit=constrain 2x',
                    mediaValue: '992px',
                    width: 0,
                    dynamic: true,
                    damPath: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      'https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Square?wid=344&fit=constrain, https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Square?wid=688&fit=constrain 2x',
                    mediaValue: '576px',
                    width: 0,
                    dynamic: true,
                    damPath: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      'https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Square?wid=575&fit=constrain, https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Square?wid=1150&fit=constrain 2x',
                    mediaValue: '576px',
                    width: 0,
                    dynamic: true,
                    damPath: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
                    mediaQuery: 'max-width',
                    height: 0,
                  },
                ],
                damPath: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
              },
              componentId: 'vadiwdqqy59xvvyr',
              headerTag: 'h2',
              impressionTrack: 'false',
              cardLayeredVariations: 'wide',
              trackingProperties: {
                enableScrollingBehavior: false,
                trackingDescription: '',
                impressionTrack: false,
                description: '',
                trackingContentPosition: '',
                atCCeVar48: '',
                rightArrowDesc: '',
                cardLocation: '',
                leftArrowDesc: '',
                clickTrack: false,
                location: '',
                merchandisingCategory: 'nonCobrand',
                impressionCount: false,
                trackingTag: '',
                trackingOfferType: '',
              },
              isAuthor: false,
              logoIcon: '',
              logoCenterAlignment: false,
              path: '/content/experience-fragments/mi-aem-ppv5-spa/global/en-us/merchandising-components/layered-wide/jcr:content/root/responsivegrid/cardcarouselcontaine/card-0/cardlayered',
              dynamicMediaTall: {
                altText: 'Healthy Breakfast',
                assetPath: 'https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100',
                enableSmartCrop: true,
                dynamic: true,
                renditions: [
                  {
                    renditionPath:
                      'https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Classic-Ver?wid=364&fit=constrain, https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Classic-Ver?wid=728&fit=constrain 2x',
                    mediaValue: '768px',
                    width: 0,
                    dynamic: true,
                    damPath: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      'https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Classic-Ver?wid=344&fit=constrain, https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Classic-Ver?wid=688&fit=constrain 2x',
                    mediaValue: '576px',
                    width: 0,
                    dynamic: true,
                    damPath: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      'https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Classic-Ver?wid=575&fit=constrain, https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Classic-Ver?wid=1150&fit=constrain 2x',
                    mediaValue: '576px',
                    width: 0,
                    dynamic: true,
                    damPath: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
                    mediaQuery: 'max-width',
                    height: 0,
                  },
                ],
                damPath: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
              },
              ':type': 'mi-aem-common-spa/components/content/cardlayered',
              badgeIcon: '',
              isFontIconEnabled: false,
              imgAltText: 'Healthy Breakfast',
              fileReferenceImage: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
              header: 'Breakfast for two each day of your stay',
              dynamicMediaWide: {
                altText: 'Healthy Breakfast',
                assetPath: 'https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100',
                enableSmartCrop: true,
                dynamic: true,
                renditions: [
                  {
                    renditionPath:
                      'https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Wide-Hor?wid=554&fit=constrain, https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Wide-Hor?wid=1108&fit=constrain 2x',
                    mediaValue: '768px',
                    width: 0,
                    dynamic: true,
                    damPath: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      'https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Wide-Hor?wid=344&fit=constrain, https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Wide-Hor?wid=688&fit=constrain 2x',
                    mediaValue: '576px',
                    width: 0,
                    dynamic: true,
                    damPath: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      'https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Wide-Hor?wid=575&fit=constrain, https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Wide-Hor?wid=1150&fit=constrain 2x',
                    mediaValue: '576px',
                    width: 0,
                    dynamic: true,
                    damPath: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
                    mediaQuery: 'max-width',
                    height: 0,
                  },
                ],
                damPath: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
              },
              fontSize: '',
              merchandisingCategory: 'nonCobrand',
              impressionCount: 'false',
              ctaLink: 'https://hotel-deals.marriott.com/breakfast/',
              openInNewTab: true,
              wcmMode: 'disabled',
            },
          },
          allowedComponents: {
            components: [],
            applicable: false,
          },
          ':type': 'mi-aem-common-spa/components/container',
          ':itemsOrder': ['cardlayered'],
          columnClassNames: {
            cardlayered: 'aem-GridColumn aem-GridColumn--default--12',
          },
          gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
          columnCount: 12,
        },
        'card-1': {
          ':items': {
            cardlayered: {
              dynamicMedia: {
                altText: 'Marriott Bonvoy Tours and Activities',
                assetPath:
                  'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-sq.jpg',
                enableSmartCrop: true,
                dynamic: false,
                renditions: [
                  {
                    renditionPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-sq.jpg?wid=365&fit=constrain',
                    mediaValue: '992px',
                    width: 0,
                    dynamic: false,
                    damPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-sq.jpg',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-sq.jpg?wid=344&fit=constrain',
                    mediaValue: '576px',
                    width: 0,
                    dynamic: false,
                    damPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-sq.jpg',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-sq.jpg?wid=575&fit=constrain',
                    mediaValue: '576px',
                    width: 0,
                    dynamic: false,
                    damPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-sq.jpg',
                    mediaQuery: 'max-width',
                    height: 0,
                  },
                ],
                damPath:
                  '/content/dam/marriott-digital/bonvoy/global/en_us/photo/under-review/assets/stock-tours-1073191.jpg',
              },
              componentId: 'iltwhowpizrjdnp2',
              headerTag: 'h2',
              impressionTrack: 'false',
              cardLayeredVariations: 'wide',
              trackingProperties: {
                enableScrollingBehavior: false,
                trackingDescription: '',
                impressionTrack: false,
                description: '',
                trackingContentPosition: '',
                atCCeVar48: '',
                rightArrowDesc: '',
                cardLocation: '',
                leftArrowDesc: '',
                clickTrack: false,
                location: '',
                merchandisingCategory: 'nonCobrand',
                impressionCount: false,
                trackingTag: '',
                trackingOfferType: '',
              },
              isAuthor: false,
              logoIcon: '',
              logoCenterAlignment: false,
              path: '/content/experience-fragments/mi-aem-ppv5-spa/global/en-us/merchandising-components/layered-wide/jcr:content/root/responsivegrid/cardcarouselcontaine/card-1/cardlayered',
              dynamicMediaTall: {
                altText: 'Marriott Bonvoy Tours and Activities',
                assetPath:
                  'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg',
                enableSmartCrop: true,
                dynamic: false,
                renditions: [
                  {
                    renditionPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg?wid=364&fit=constrain',
                    mediaValue: '768px',
                    width: 0,
                    dynamic: false,
                    damPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg?wid=344&fit=constrain',
                    mediaValue: '576px',
                    width: 0,
                    dynamic: false,
                    damPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg?wid=575&fit=constrain',
                    mediaValue: '576px',
                    width: 0,
                    dynamic: false,
                    damPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg',
                    mediaQuery: 'max-width',
                    height: 0,
                  },
                ],
                damPath:
                  '/content/dam/marriott-digital/bonvoy/global/en_us/photo/under-review/assets/stock-tours-1073191.jpg',
              },
              ':type': 'mi-aem-common-spa/components/content/cardlayered',
              badgeIcon: '',
              isFontIconEnabled: false,
              imgAltText: 'Marriott Bonvoy Tours and Activities',
              fileReferenceImage:
                '/content/dam/marriott-digital/bonvoy/global/en_us/photo/under-review/assets/stock-tours-1073191.jpg',
              header: 'Discover travel activities globally',
              dynamicMediaWide: {
                altText: 'Marriott Bonvoy Tours and Activities',
                assetPath:
                  'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg',
                enableSmartCrop: true,
                dynamic: false,
                renditions: [
                  {
                    renditionPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg?wid=554&fit=constrain',
                    mediaValue: '768px',
                    width: 0,
                    dynamic: false,
                    damPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg?wid=344&fit=constrain',
                    mediaValue: '576px',
                    width: 0,
                    dynamic: false,
                    damPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg?wid=575&fit=constrain',
                    mediaValue: '576px',
                    width: 0,
                    dynamic: false,
                    damPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg',
                    mediaQuery: 'max-width',
                    height: 0,
                  },
                ],
                damPath:
                  '/content/dam/marriott-digital/bonvoy/global/en_us/photo/under-review/assets/stock-tours-1073191.jpg',
              },
              fontSize: '',
              merchandisingCategory: 'nonCobrand',
              impressionCount: 'false',
              ctaLink: 'https://activities.marriott.com/',
              openInNewTab: true,
              wcmMode: 'disabled',
            },
          },
          allowedComponents: {
            components: [],
            applicable: false,
          },
          ':type': 'mi-aem-common-spa/components/container',
          ':itemsOrder': ['cardlayered'],
          columnClassNames: {
            cardlayered: 'aem-GridColumn aem-GridColumn--default--12',
          },
          gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
          columnCount: 12,
        },
      },
      path: '/content/experience-fragments/mi-aem-ppv5-spa/global/en-us/merchandising-components/layered-wide/jcr:content/root/responsivegrid/cardcarouselcontaine',
      ctaType: 'primaryButton',
      ':type': 'mi-aem-common-spa/components/content/cardcarouselcontainer',
      openInaNewTab: false,
      ':itemsOrder': ['card-0', 'card-1'],
      itemPath:
        '/content/experience-fragments/mi-aem-ppv5-spa/global/en-us/merchandising-components/layered-wide/jcr:content/root/responsivegrid/cardcarouselcontaine',
      totalNumberOfCards: ['card-0', 'card-1'],
      items: [],
      noOfCardsTablet: 2,
      wcmMode: 'disabled',
    },
  },
};

export const propertyPortalTargetMock = {
  componentId: 'merchendising-layered-wide',
  headerText: 'Recommended For You',
  cardTypes: 'cardlayered',
  cardCount: 2,
  noOfCards: 2,
  pagePath: '/content/marriott-hws/na/en-us/hotels/n/nycmq-new-york-marriott-marquis/ppv5-phoenix/homepage',
  trackingProperties: {
    enableScrollingBehavior: false,
    trackingDescription: '',
    impressionTrack: false,
    description: '',
    trackingContentPosition: '',
    atCCeVar48: '',
    rightArrowDesc: '',
    cardLocation: '',
    leftArrowDesc: '',
    clickTrack: true,
    location: '',
    merchandisingCategory: '',
    impressionCount: false,
    trackingTag: '',
    trackingOfferType: '',
  },
  variation: 'standard',
  isAuthor: false,
  ':items': {
    'container-0': {
      ':items': {
        'card-0': {
          ':items': {
            cardlayered: {
              dynamicMedia: {
                altText: 'Healthy Breakfast',
                assetPath: 'https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100',
                enableSmartCrop: true,
                dynamic: true,
                renditions: [
                  {
                    renditionPath:
                      'https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Square?wid=365&fit=constrain, https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Square?wid=730&fit=constrain 2x',
                    mediaValue: '992px',
                    width: 0,
                    dynamic: true,
                    damPath: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      'https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Square?wid=344&fit=constrain, https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Square?wid=688&fit=constrain 2x',
                    mediaValue: '576px',
                    width: 0,
                    dynamic: true,
                    damPath: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      'https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Square?wid=575&fit=constrain, https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Square?wid=1150&fit=constrain 2x',
                    mediaValue: '576px',
                    width: 0,
                    dynamic: true,
                    damPath: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
                    mediaQuery: 'max-width',
                    height: 0,
                  },
                ],
                damPath: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
              },
              componentId: 'vadiwdqqy59xvvyr',
              headerTag: 'h2',
              impressionTrack: 'false',
              cardLayeredVariations: 'wide',
              trackingProperties: {
                enableScrollingBehavior: false,
                trackingDescription: '',
                impressionTrack: false,
                description: '',
                trackingContentPosition: '',
                atCCeVar48: '',
                rightArrowDesc: '',
                cardLocation: '',
                leftArrowDesc: '',
                clickTrack: false,
                location: '',
                merchandisingCategory: 'nonCobrand',
                impressionCount: false,
                trackingTag: '',
                trackingOfferType: '',
              },
              isAuthor: false,
              logoIcon: '',
              logoCenterAlignment: false,
              path: '/content/experience-fragments/mi-aem-ppv5-spa/global/en-us/merchandising-components/layered-wide/jcr:content/root/responsivegrid/cardcarouselcontaine/card-0/cardlayered',
              dynamicMediaTall: {
                altText: 'Healthy Breakfast',
                assetPath: 'https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100',
                enableSmartCrop: true,
                dynamic: true,
                renditions: [
                  {
                    renditionPath:
                      'https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Classic-Ver?wid=364&fit=constrain, https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Classic-Ver?wid=728&fit=constrain 2x',
                    mediaValue: '768px',
                    width: 0,
                    dynamic: true,
                    damPath: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      'https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Classic-Ver?wid=344&fit=constrain, https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Classic-Ver?wid=688&fit=constrain 2x',
                    mediaValue: '576px',
                    width: 0,
                    dynamic: true,
                    damPath: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      'https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Classic-Ver?wid=575&fit=constrain, https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Classic-Ver?wid=1150&fit=constrain 2x',
                    mediaValue: '576px',
                    width: 0,
                    dynamic: true,
                    damPath: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
                    mediaQuery: 'max-width',
                    height: 0,
                  },
                ],
                damPath: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
              },
              ':type': 'mi-aem-common-spa/components/content/cardlayered',
              badgeIcon: '',
              isFontIconEnabled: false,
              imgAltText: 'Healthy Breakfast',
              fileReferenceImage: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
              header: 'Breakfast for two each day of your stay',
              dynamicMediaWide: {
                altText: 'Healthy Breakfast',
                assetPath: 'https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100',
                enableSmartCrop: true,
                dynamic: true,
                renditions: [
                  {
                    renditionPath:
                      'https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Wide-Hor?wid=554&fit=constrain, https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Wide-Hor?wid=1108&fit=constrain 2x',
                    mediaValue: '768px',
                    width: 0,
                    dynamic: true,
                    damPath: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      'https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Wide-Hor?wid=344&fit=constrain, https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Wide-Hor?wid=688&fit=constrain 2x',
                    mediaValue: '576px',
                    width: 0,
                    dynamic: true,
                    damPath: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      'https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Wide-Hor?wid=575&fit=constrain, https://s7d1.scene7.com/is/image/marriotts7prod/pdt-234315218194100:Wide-Hor?wid=1150&fit=constrain 2x',
                    mediaValue: '576px',
                    width: 0,
                    dynamic: true,
                    damPath: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
                    mediaQuery: 'max-width',
                    height: 0,
                  },
                ],
                damPath: '/content/dam/marriott-digital/mcomppv5/global/en_us/assets/pdt-234315218194100.jpg',
              },
              fontSize: '',
              merchandisingCategory: 'nonCobrand',
              impressionCount: 'false',
              ctaLink: 'https://hotel-deals.marriott.com/breakfast/',
              openInNewTab: true,
              wcmMode: 'disabled',
            },
          },
          allowedComponents: {
            components: [],
            applicable: false,
          },
          ':type': 'mi-aem-common-spa/components/container',
          ':itemsOrder': ['cardlayered'],
          columnClassNames: {
            cardlayered: 'aem-GridColumn aem-GridColumn--default--12',
          },
          gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
          columnCount: 12,
        },
        'card-1': {
          ':items': {
            cardlayered: {
              dynamicMedia: {
                altText: 'Marriott Bonvoy Tours and Activities',
                assetPath:
                  'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-sq.jpg',
                enableSmartCrop: true,
                dynamic: false,
                renditions: [
                  {
                    renditionPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-sq.jpg?wid=365&fit=constrain',
                    mediaValue: '992px',
                    width: 0,
                    dynamic: false,
                    damPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-sq.jpg',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-sq.jpg?wid=344&fit=constrain',
                    mediaValue: '576px',
                    width: 0,
                    dynamic: false,
                    damPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-sq.jpg',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-sq.jpg?wid=575&fit=constrain',
                    mediaValue: '576px',
                    width: 0,
                    dynamic: false,
                    damPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-sq.jpg',
                    mediaQuery: 'max-width',
                    height: 0,
                  },
                ],
                damPath:
                  '/content/dam/marriott-digital/bonvoy/global/en_us/photo/under-review/assets/stock-tours-1073191.jpg',
              },
              componentId: 'iltwhowpizrjdnp2',
              headerTag: 'h2',
              impressionTrack: 'false',
              cardLayeredVariations: 'wide',
              trackingProperties: {
                enableScrollingBehavior: false,
                trackingDescription: '',
                impressionTrack: false,
                description: '',
                trackingContentPosition: '',
                atCCeVar48: '',
                rightArrowDesc: '',
                cardLocation: '',
                leftArrowDesc: '',
                clickTrack: false,
                location: '',
                merchandisingCategory: 'nonCobrand',
                impressionCount: false,
                trackingTag: '',
                trackingOfferType: '',
              },
              isAuthor: false,
              logoIcon: '',
              logoCenterAlignment: false,
              path: '/content/experience-fragments/mi-aem-ppv5-spa/global/en-us/merchandising-components/layered-wide/jcr:content/root/responsivegrid/cardcarouselcontaine/card-1/cardlayered',
              dynamicMediaTall: {
                altText: 'Marriott Bonvoy Tours and Activities',
                assetPath:
                  'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg',
                enableSmartCrop: true,
                dynamic: false,
                renditions: [
                  {
                    renditionPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg?wid=364&fit=constrain',
                    mediaValue: '768px',
                    width: 0,
                    dynamic: false,
                    damPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg?wid=344&fit=constrain',
                    mediaValue: '576px',
                    width: 0,
                    dynamic: false,
                    damPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg?wid=575&fit=constrain',
                    mediaValue: '576px',
                    width: 0,
                    dynamic: false,
                    damPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg',
                    mediaQuery: 'max-width',
                    height: 0,
                  },
                ],
                damPath:
                  '/content/dam/marriott-digital/bonvoy/global/en_us/photo/under-review/assets/stock-tours-1073191.jpg',
              },
              ':type': 'mi-aem-common-spa/components/content/cardlayered',
              badgeIcon: '',
              isFontIconEnabled: false,
              imgAltText: 'Marriott Bonvoy Tours and Activities',
              fileReferenceImage:
                '/content/dam/marriott-digital/bonvoy/global/en_us/photo/under-review/assets/stock-tours-1073191.jpg',
              header: 'Discover travel activities globally',
              dynamicMediaWide: {
                altText: 'Marriott Bonvoy Tours and Activities',
                assetPath:
                  'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg',
                enableSmartCrop: true,
                dynamic: false,
                renditions: [
                  {
                    renditionPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg?wid=554&fit=constrain',
                    mediaValue: '768px',
                    width: 0,
                    dynamic: false,
                    damPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg?wid=344&fit=constrain',
                    mediaValue: '576px',
                    width: 0,
                    dynamic: false,
                    damPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg',
                    mediaQuery: 'min-width',
                    height: 0,
                  },
                  {
                    renditionPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg?wid=575&fit=constrain',
                    mediaValue: '576px',
                    width: 0,
                    dynamic: false,
                    damPath:
                      'https://marriott-sites2-qa.adobecqms.net/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg',
                    mediaQuery: 'max-width',
                    height: 0,
                  },
                ],
                damPath:
                  '/content/dam/marriott-digital/bonvoy/global/en_us/photo/under-review/assets/stock-tours-1073191.jpg',
              },
              fontSize: '',
              merchandisingCategory: 'nonCobrand',
              impressionCount: 'false',
              ctaLink: 'https://activities.marriott.com/',
              openInNewTab: true,
              wcmMode: 'disabled',
            },
          },
          allowedComponents: {
            components: [],
            applicable: false,
          },
          ':type': 'mi-aem-common-spa/components/container',
          ':itemsOrder': ['cardlayered'],
          columnClassNames: {
            cardlayered: 'aem-GridColumn aem-GridColumn--default--12',
          },
          gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
          columnCount: 12,
        },
      },
      ':type': 'mi-aem-common-spa/components/content/cardcarouselcontainer',
    },
  },
  path: '/content/experience-fragments/mi-aem-ppv5-spa/global/en-us/merchandising-components/layered-wide/jcr:content/root/responsivegrid/cardcarouselcontaine',
  ctaType: 'primaryButton',
  ':type': 'mi-aem-common-spa/components/content/cardcarouselcontainer',
  openInaNewTab: false,
  ':itemsOrder': ['card-0', 'card-1'],
  itemPath:
    '/content/experience-fragments/mi-aem-ppv5-spa/global/en-us/merchandising-components/layered-wide/jcr:content/root/responsivegrid/cardcarouselcontaine',
  totalNumberOfCards: ['card-0', 'card-1'],
  items: [],
  noOfCardsTablet: 2,
  wcmMode: 'disabled',
};

export const PropertyPortalMerchandisingMockData = {
  type: 'mi-aem-common-spa/components/content/cardcarouselcontainer',
  componentProps: {
    model: {
      ':items': {
        'card-0': {
          ':items': {
            cardlayered: {
              ':type': 'mi-aem-common-spa/components/content/cardlayered',
              cardLayeredVariations: 'wide',
              componentId: 'uirwbbcn005dbf8r',
              ctaLink: 'https://www.marriott.com/credit-cards.mi',
              dynamicMedia: {
                altText: 'Serene beach getaway',
                assetPath: 'https://cache.marriott.com/is/image/marriotts7prod/wi-dpswi-serene-beach-getaway-17351',
                damPath:
                  '/content/dam/marriott-digital/wi/apec/hws/d/dpswi/en_us/photo/unlimited/assets/wi-dpswi-serene-beach-getaway-17351.jpg',
                dynamic: true,
                enableSmartCrop: true,
                renditions: [
                  {
                    damPath:
                      '/content/dam/marriott-digital/wi/apec/hws/d/dpswi/en_us/photo/unlimited/assets/wi-dpswi-serene-beach-getaway-17351.jpg',
                    dynamic: true,
                    height: 0,
                    mediaQuery: 'min-width',
                    mediaValue: '1200px',
                    renditionPath:
                      'https://cache.marriott.com/is/image/marriotts7prod/wi-dpswi-serene-beach-getaway-17351:Square?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/wi-dpswi-serene-beach-getaway-17351:Square?wid=760&fit=constrain 2x',
                    smartCropType: null,
                    width: 0,
                  },
                  {
                    damPath:
                      '/content/dam/marriott-digital/wi/apec/hws/d/dpswi/en_us/photo/unlimited/assets/wi-dpswi-serene-beach-getaway-17351.jpg',
                    dynamic: true,
                    height: 0,
                    mediaQuery: 'min-width',
                    mediaValue: '768px',
                    renditionPath:
                      'https://cache.marriott.com/is/image/marriotts7prod/wi-dpswi-serene-beach-getaway-17351:Square?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/wi-dpswi-serene-beach-getaway-17351:Square?wid=960&fit=constrain 2x',
                    smartCropType: null,
                    width: 0,
                  },
                  {
                    damPath:
                      '/content/dam/marriott-digital/wi/apec/hws/d/dpswi/en_us/photo/unlimited/assets/wi-dpswi-serene-beach-getaway-17351.jpg',
                    dynamic: true,
                    height: 0,
                    mediaQuery: 'max-width',
                    mediaValue: '768px',
                    renditionPath:
                      'https://cache.marriott.com/is/image/marriotts7prod/wi-dpswi-serene-beach-getaway-17351:Square?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/wi-dpswi-serene-beach-getaway-17351:Square?wid=1150&fit=constrain 2x',
                    smartCropType: null,
                    width: 0,
                  },
                ],
                renditionUrl: null,
              },
              dynamicMediaTall: {
                altText: 'Serene beach getaway',
                assetPath: 'https://cache.marriott.com/is/image/marriotts7prod/wi-dpswi-serene-beach-getaway-17351',
                damPath:
                  '/content/dam/marriott-digital/wi/apec/hws/d/dpswi/en_us/photo/unlimited/assets/wi-dpswi-serene-beach-getaway-17351.jpg',
                dynamic: true,
                enableSmartCrop: true,
                renditions: [
                  {
                    damPath:
                      '/content/dam/marriott-digital/wi/apec/hws/d/dpswi/en_us/photo/unlimited/assets/wi-dpswi-serene-beach-getaway-17351.jpg',
                    dynamic: true,
                    height: 0,
                    mediaQuery: 'min-width',
                    mediaValue: '1200px',
                    renditionPath:
                      'https://cache.marriott.com/is/image/marriotts7prod/wi-dpswi-serene-beach-getaway-17351:Classic-Ver?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/wi-dpswi-serene-beach-getaway-17351:Classic-Ver?wid=760&fit=constrain 2x',
                    smartCropType: null,
                    width: 0,
                  },
                  {
                    damPath:
                      '/content/dam/marriott-digital/wi/apec/hws/d/dpswi/en_us/photo/unlimited/assets/wi-dpswi-serene-beach-getaway-17351.jpg',
                    dynamic: true,
                    height: 0,
                    mediaQuery: 'min-width',
                    mediaValue: '768px',
                    renditionPath:
                      'https://cache.marriott.com/is/image/marriotts7prod/wi-dpswi-serene-beach-getaway-17351:Classic-Ver?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/wi-dpswi-serene-beach-getaway-17351:Classic-Ver?wid=960&fit=constrain 2x',
                    smartCropType: null,
                    width: 0,
                  },
                  {
                    damPath:
                      '/content/dam/marriott-digital/wi/apec/hws/d/dpswi/en_us/photo/unlimited/assets/wi-dpswi-serene-beach-getaway-17351.jpg',
                    dynamic: true,
                    height: 0,
                    mediaQuery: 'max-width',
                    mediaValue: '768px',
                    renditionPath:
                      'https://cache.marriott.com/is/image/marriotts7prod/wi-dpswi-serene-beach-getaway-17351:Classic-Ver?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/wi-dpswi-serene-beach-getaway-17351:Classic-Ver?wid=1150&fit=constrain 2x',
                    smartCropType: null,
                    width: 0,
                  },
                ],
                renditionUrl: null,
              },
              dynamicMediaWide: {
                altText: 'Serene beach getaway',
                assetPath: 'https://cache.marriott.com/is/image/marriotts7prod/wi-dpswi-serene-beach-getaway-17351',
                damPath:
                  '/content/dam/marriott-digital/wi/apec/hws/d/dpswi/en_us/photo/unlimited/assets/wi-dpswi-serene-beach-getaway-17351.jpg',
                dynamic: true,
                enableSmartCrop: true,
                renditions: [
                  {
                    damPath:
                      '/content/dam/marriott-digital/wi/apec/hws/d/dpswi/en_us/photo/unlimited/assets/wi-dpswi-serene-beach-getaway-17351.jpg',
                    dynamic: true,
                    height: 0,
                    mediaQuery: 'min-width',
                    mediaValue: '1200px',
                    renditionPath:
                      'https://cache.marriott.com/is/image/marriotts7prod/wi-dpswi-serene-beach-getaway-17351:Wide-Hor?wid=570&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/wi-dpswi-serene-beach-getaway-17351:Wide-Hor?wid=1140&fit=constrain 2x',
                    smartCropType: null,
                    width: 0,
                  },
                  {
                    damPath:
                      '/content/dam/marriott-digital/wi/apec/hws/d/dpswi/en_us/photo/unlimited/assets/wi-dpswi-serene-beach-getaway-17351.jpg',
                    dynamic: true,
                    height: 0,
                    mediaQuery: 'min-width',
                    mediaValue: '768px',
                    renditionPath:
                      'https://cache.marriott.com/is/image/marriotts7prod/wi-dpswi-serene-beach-getaway-17351:Wide-Hor?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/wi-dpswi-serene-beach-getaway-17351:Wide-Hor?wid=960&fit=constrain 2x',
                    smartCropType: null,
                    width: 0,
                  },
                  {
                    damPath:
                      '/content/dam/marriott-digital/wi/apec/hws/d/dpswi/en_us/photo/unlimited/assets/wi-dpswi-serene-beach-getaway-17351.jpg',
                    dynamic: true,
                    height: 0,
                    mediaQuery: 'max-width',
                    mediaValue: '768px',
                    renditionPath:
                      'https://cache.marriott.com/is/image/marriotts7prod/wi-dpswi-serene-beach-getaway-17351:Wide-Hor?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/wi-dpswi-serene-beach-getaway-17351:Wide-Hor?wid=1150&fit=constrain 2x',
                    smartCropType: null,
                    width: 0,
                  },
                ],
                renditionUrl: null,
              },
              fileReferenceImage:
                '/content/dam/marriott-digital/wi/apec/hws/d/dpswi/en_us/photo/unlimited/assets/wi-dpswi-serene-beach-getaway-17351.jpg',
              fontSize: '',
              header: 'Marriott Bonvoy™ Credit Cards',
              headerTag: 'h2',
              imgAltText: 'Serene beach getaway',
              impressionCount: 'false',
              impressionTrack: 'false',
              isAuthor: false,
              logoIcon: '',
              merchandisingCategory: 'nonCobrand',
              openInNewTab: true,
              path: '/content/experience-fragments/mi-aem-ppv5-spa/global/en-us/merchandising-components/layered-wide/jcr:content/root/responsivegrid/cardcarouselcontaine/card-0/cardlayered',
              trackingProperties: {
                additionalTrackingVariables: '',
                atCCeVar48: '',
                cardLocation: '',
                clickTrack: false,
                description: '',
                enableScrollingBehavior: false,
                faicMCD: '',
                impressionCount: false,
                impressionTrack: false,
                leftArrowDesc: '',
                location: '',
                merchandisingCategory: 'nonCobrand',
                rightArrowDesc: '',
                trackingContentPosition: '',
                trackingDescription: '',
                trackingOfferType: '',
                trackingTag: '',
              },
              wcmMode: 'disabled',
            },
          },
          ':itemsOrder': ['cardlayered'],
          ':type': 'mi-aem-common-spa/components/container',
          allowedComponents: {
            applicable: false,
            components: [],
          },
          columnClassNames: {
            cardlayered: 'aem-GridColumn aem-GridColumn--default--12',
          },
          columnCount: 12,
          gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
        },
        'card-1': {
          ':items': {
            cardlayered: {
              ':type': 'mi-aem-common-spa/components/content/cardlayered',
              cardLayeredVariations: 'wide',
              componentId: 'ajyklncp6o0rkf4n',
              ctaLink: 'https://activities.marriott.com/',
              dynamicMedia: {
                altText: 'Marriott Bonvoy Tours and Activities',
                assetPath:
                  'https://cache.marriott.com/content/dam/marriott-digital/bonvoy/global/en_us/photo/under-review/assets/stock-tours-1073191.jpg',
                damPath:
                  '/content/dam/marriott-digital/bonvoy/global/en_us/photo/under-review/assets/stock-tours-1073191.jpg',
                dynamic: true,
                enableSmartCrop: true,
                renditions: [
                  {
                    damPath:
                      'https://cache.marriott.com/content/dam/marriott-renditions/Stock/stock-tours-1073191-sq.jpg',
                    dynamic: true,
                    height: 0,
                    mediaQuery: 'min-width',
                    mediaValue: '1200px',
                    renditionPath:
                      'https://cache.marriott.com/content/dam/marriott-renditions/Stock/stock-tours-1073191-sq.jpg?wid=380&fit=constrain',
                    smartCropType: null,
                    width: 0,
                  },
                  {
                    damPath:
                      'https://cache.marriott.com/content/dam/marriott-renditions/Stock/stock-tours-1073191-sq.jpg',
                    dynamic: true,
                    height: 0,
                    mediaQuery: 'min-width',
                    mediaValue: '768px',
                    renditionPath:
                      'https://cache.marriott.com/content/dam/marriott-renditions/Stock/stock-tours-1073191-sq.jpg?wid=480&fit=constrain',
                    smartCropType: null,
                    width: 0,
                  },
                  {
                    damPath:
                      'https://cache.marriott.com/content/dam/marriott-renditions/Stock/stock-tours-1073191-sq.jpg',
                    dynamic: true,
                    height: 0,
                    mediaQuery: 'max-width',
                    mediaValue: '768px',
                    renditionPath:
                      'https://cache.marriott.com/content/dam/marriott-renditions/Stock/stock-tours-1073191-sq.jpg?wid=575&fit=constrain',
                    smartCropType: null,
                    width: 0,
                  },
                ],
                renditionUrl: null,
              },
              dynamicMediaTall: {
                altText: 'Marriott Bonvoy Tours and Activities',
                assetPath:
                  'https://cache.marriott.com/content/dam/marriott-digital/bonvoy/global/en_us/photo/under-review/assets/stock-tours-1073191.jpg',
                damPath:
                  '/content/dam/marriott-digital/bonvoy/global/en_us/photo/under-review/assets/stock-tours-1073191.jpg',
                dynamic: true,
                enableSmartCrop: true,
                renditions: [
                  {
                    damPath:
                      'https://cache.marriott.com/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg',
                    dynamic: true,
                    height: 0,
                    mediaQuery: 'min-width',
                    mediaValue: '1200px',
                    renditionPath:
                      'https://cache.marriott.com/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg?wid=380&fit=constrain',
                    smartCropType: null,
                    width: 0,
                  },
                  {
                    damPath:
                      'https://cache.marriott.com/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg',
                    dynamic: true,
                    height: 0,
                    mediaQuery: 'min-width',
                    mediaValue: '768px',
                    renditionPath:
                      'https://cache.marriott.com/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg?wid=480&fit=constrain',
                    smartCropType: null,
                    width: 0,
                  },
                  {
                    damPath:
                      'https://cache.marriott.com/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg',
                    dynamic: true,
                    height: 0,
                    mediaQuery: 'max-width',
                    mediaValue: '768px',
                    renditionPath:
                      'https://cache.marriott.com/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg?wid=575&fit=constrain',
                    smartCropType: null,
                    width: 0,
                  },
                ],
                renditionUrl: null,
              },
              dynamicMediaWide: {
                altText: 'Marriott Bonvoy Tours and Activities',
                assetPath:
                  'https://cache.marriott.com/content/dam/marriott-digital/bonvoy/global/en_us/photo/under-review/assets/stock-tours-1073191.jpg',
                damPath:
                  '/content/dam/marriott-digital/bonvoy/global/en_us/photo/under-review/assets/stock-tours-1073191.jpg',
                dynamic: true,
                enableSmartCrop: true,
                renditions: [
                  {
                    damPath:
                      'https://cache.marriott.com/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg',
                    dynamic: true,
                    height: 0,
                    mediaQuery: 'min-width',
                    mediaValue: '1200px',
                    renditionPath:
                      'https://cache.marriott.com/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg?wid=570&fit=constrain',
                    smartCropType: null,
                    width: 0,
                  },
                  {
                    damPath:
                      'https://cache.marriott.com/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg',
                    dynamic: true,
                    height: 0,
                    mediaQuery: 'min-width',
                    mediaValue: '768px',
                    renditionPath:
                      'https://cache.marriott.com/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg?wid=480&fit=constrain',
                    smartCropType: null,
                    width: 0,
                  },
                  {
                    damPath:
                      'https://cache.marriott.com/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg',
                    dynamic: true,
                    height: 0,
                    mediaQuery: 'max-width',
                    mediaValue: '768px',
                    renditionPath:
                      'https://cache.marriott.com/content/dam/marriott-renditions/Stock/stock-tours-1073191-hor-wide.jpg?wid=575&fit=constrain',
                    smartCropType: null,
                    width: 0,
                  },
                ],
                renditionUrl: null,
              },
              fileReferenceImage:
                '/content/dam/marriott-digital/bonvoy/global/en_us/photo/under-review/assets/stock-tours-1073191.jpg',
              fontSize: '',
              header: 'Discover travel activities globally',
              headerTag: 'h2',
              imgAltText: 'Marriott Bonvoy Tours and Activities',
              impressionCount: 'false',
              impressionTrack: 'false',
              isAuthor: false,
              logoIcon: '',
              merchandisingCategory: 'nonCobrand',
              openInNewTab: true,
              path: '/content/experience-fragments/mi-aem-ppv5-spa/global/en-us/merchandising-components/layered-wide/jcr:content/root/responsivegrid/cardcarouselcontaine/card-1/cardlayered',
              trackingProperties: {
                additionalTrackingVariables: '',
                atCCeVar48: '',
                cardLocation: '',
                clickTrack: false,
                description: '',
                enableScrollingBehavior: false,
                faicMCD: '',
                impressionCount: false,
                impressionTrack: false,
                leftArrowDesc: '',
                location: '',
                merchandisingCategory: 'nonCobrand',
                rightArrowDesc: '',
                trackingContentPosition: '',
                trackingDescription: '',
                trackingOfferType: '',
                trackingTag: '',
              },
              wcmMode: 'disabled',
            },
          },
          ':itemsOrder': ['cardlayered'],
          ':type': 'mi-aem-common-spa/components/container',
          allowedComponents: {
            applicable: false,
            components: [],
          },
          columnClassNames: {
            cardlayered: 'aem-GridColumn aem-GridColumn--default--12',
          },
          columnCount: 12,
          gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
        },
      },
      ':itemsOrder': ['card-0', 'card-1'],
      ':type': 'mi-aem-common-spa/components/content/cardcarouselcontainer',
      cardCount: 2,
      cardTypes: 'cardlayered',
      componentId: 'target-propertyPortal-mbox',
      cqType: 'mi-aem-common-spa/components/content/cardcarouselcontainer',
      ctaType: 'primaryButton',
      headerText: 'Recommended For You',
      isAuthor: false,
      itemPath:
        '/content/experience-fragments/mi-aem-ppv5-spa/global/en-us/merchandising-components/layered-wide/jcr:content/root/responsivegrid/cardcarouselcontaine',
      modelFactory: {},
      noOfCards: 2,
      noOfCardsTablet: 2,
      openInaNewTab: false,
      pagePath:
        '/content/marriott-hws/na/en-us/hotels/m/mianm-residence-inn-miami-sunny-isles-beach/ppv5-phoenix/homepage',
      path: '/content/experience-fragments/mi-aem-ppv5-spa/global/en-us/merchandising-components/layered-wide/jcr:content/root/responsivegrid/cardcarouselcontaine',
      totalNumberOfCards: ['card-0', 'card-1'],
      trackingProperties: {
        additionalTrackingVariables: '',
        atCCeVar48: '',
        cardLocation: '',
        clickTrack: true,
        description: '',
        enableScrollingBehavior: false,
        faicMCD: '',
        impressionCount: false,
        impressionTrack: false,
        leftArrowDesc: '',
        location: '',
        merchandisingCategory: '',
        rightArrowDesc: '',
        trackingContentPosition: '',
        trackingDescription: '',
        trackingOfferType: '',
        trackingTag: '',
      },
      variation: 'standard',
      wcmMode: 'disabled',
    },
  },
};
